import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { h5Styles } from '@luigiclaudio/ga-baseline-ui/typography';
import { media } from '@luigiclaudio/ga-baseline-ui/layout';

const ColorVarianStepBarValue = styled.span`
    ${h5Styles}
    font-size: ${rem(11)};
    margin: 0;
    padding: ${rem(4)};

    ${media.xxs`
        padding: ${rem(4)} ${rem(6)};
    `}

    ${media.xs`
        font-size: ${rem(14)};
        padding: ${rem(4)} ${rem(8)};
    `}   

    ${({ themeMode }) =>
        themeMode === 'lightMode' &&
        css`
            color: ${({ theme }) => theme.base.grays.grayLighter};
        `}

    ${({ themeMode }) =>
        themeMode === 'darkMode' &&
        css`
            color: ${({ theme }) => theme.base.grays.grayLight};
        `}
`;

export default ColorVarianStepBarValue;
